import { Box, Flex } from '@chakra-ui/react';
import useScrollToTop from 'hooks/shared/useScrollToTop';
import Footer from 'presentation/layout/shared/Footer/Footer';
import { headerHeight } from 'presentation/layout/shared/Header/Header';
import PageLayout from 'presentation/layout/shared/page/PageLayout';
import { FC, PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const EventsPageLayout: FC<PropsWithChildren> = ({ children }) => {
  const scrollableBody = useScrollToTop();

  const { pathname, search } = useLocation();

  useEffect(() => {
    if (scrollableBody) {
      scrollableBody.current?.scrollTo(0, 0);
    }
  }, [pathname, search]);

  return (
    <PageLayout>
      <Flex flexDirection="column" height="100vh">
        <Flex
          minW="980px"
          flexDir="column"
          minH={`calc(100vh - ${headerHeight}px)`}
          flex="1"
          overflow="auto"
          pt="20px"
          justifyContent="space-between"
          ref={scrollableBody}
        >
          <Box mb="20px">{children}</Box>
          <Footer />
        </Flex>
      </Flex>
    </PageLayout>
  );
};

export default EventsPageLayout;
